import React, { useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useResetInputs } from "src/Contexts";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { ModalCore } from "src/Pages/components";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { FormOperadora } from "./FormularioOperadora";
import { UseFormOperadora } from "./Hook/UseFeaturesFormulario";

interface IModalOperadora {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ModalOperadora = ({
  openModal,
  setOpenModal,
}: IModalOperadora) => {
  const { userPerfil } = useAuthContext();
  const { resetInputs } = useResetInputs();

  const { handleSubmit, loading: loadingSubmit } = UseFormOperadora({
    setOpenModal,
  });

  useEffect(() => {
    if (!openModal) resetInputs();
  }, [openModal]);

  return (
    <>
      <ButtonCore
        disabled={
          userPerfil?.type_user === "USER" &&
          !userPerfil?.permissions.permissions.includes(
            valuesPermissions.OPERADORA.CREATE.id
          )
        }
        startIcon={<AddIcon />}
        title="Criar Operadora"
        onClick={() => setOpenModal(true)}
      />

      <ModalCore
        loadingSubmit={loadingSubmit}
        open={openModal}
        setOpen={setOpenModal}
        sxStyle={{ width: "500px" }}
        title="Operadora"
        titleSubmit="Salvar"
        onChange={handleSubmit}
      >
        <FormOperadora />
      </ModalCore>
    </>
  );
};
